<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isInformationDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState } from 'vuex'
export default {
  name: 'InfoEprotectionEdit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_GOODSTYPE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/information/informationUpdate',
      formAddUrl: '/modules/information/informationAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '资讯标题',
            key: 'title',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 50, message: '资讯标题长度不能超过50', trigger: 'blur' }
            ] },
          { name: '资讯标签', key: 'typeId', type: 'select', required: true, disabled: false, data: [] },
          { name: '资讯封面', key: 'coverPathList', type: 'image', required: true, disabled: false, limit: 1, markText: '上传图片尺寸686x300px' },
          { name: '资讯内容', key: 'content', type: 'editor', required: true, disabled: false }]
      }
    }
  },
  created() {
    this.requestTypeList()
    if (this.componentType === 'add') {
      // this.detailFormData.content = '<p></p>'
    }
    if (this.componentType === 'edit') {
      this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddGoodsTypeDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateGoodsTypeDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddGoodsTypeDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      delete sendData.coverPathList
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateGoodsTypeDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      delete sendData.coverPathList
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    requestTypeList() {
      request({
        url: '/modules/informationType/informationTypeListNoPage',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.detailForm.elements[1].data = res.data
        }
      })
    }
  },
  computed: {
    ...mapState({
      isInformationDetailLoading: state => state.information.isInformationDetailLoading,
      detailFormData: state => state.information.informationDetailData
    })
  }
}
</script>

<style scoped>

</style>
